import { render, staticRenderFns } from "./LegalAtlases.vue?vue&type=template&id=1586c4ea&"
import script from "./LegalAtlases.vue?vue&type=script&lang=js&"
export * from "./LegalAtlases.vue?vue&type=script&lang=js&"
import style0 from "./LegalAtlases.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports